<template>
	<div class="container">
		<div class="row">
			<form class="form-inline">
				<div class="form-group mb-2">
					<input type="text" class="form-control" v-model="wallet[0]">
				</div>
				<button type="submit" class="btn btn-primary mx-sm-2 mb-2" @click.prevent="registerSinger(0)">Add Singer
					1
				</button>
			</form>
		</div>
		<br>
		<div class="row">
			<form class="form-inline">
				<div class="form-group mb-2">
					<input type="text" class="form-control" v-model="wallet[1]">
				</div>
				<button type="submit" class="btn btn-primary mx-sm-2 mb-2" @click.prevent="registerSinger(1)">Add Singer
					2
				</button>
			</form>
		</div>
		<br>
		<div class="row">
			<form class="form-inline">
				<div class="form-group mb-2">
					<input type="text" class="form-control" v-model="wallet[2]">
				</div>
				<button type="submit" class="btn btn-primary mx-sm-2 mb-2" @click.prevent="registerSinger(2)">Add Singer
					3
				</button>
			</form>
		</div>
		<br>
		<div class="row">
			<form class="form-inline">
				<div class="form-group mb-2">
					<input type="text" class="form-control" v-model="wallet[3]">
				</div>
				<button type="submit" class="btn btn-primary mx-sm-2 mb-2" @click.prevent="registerSinger(3)">Add Singer
					4
				</button>
			</form>
		</div>
		<br>
		<div class="row">
			<form class="form-inline">
				<div class="form-group mb-2">
					<input type="text" class="form-control" v-model="wallet[4]">
				</div>
				<button type="submit" class="btn btn-primary mx-sm-2 mb-2" @click.prevent="registerSinger(4)">Add Singer
					5
				</button>
			</form>
		</div>
		<br>
		<div class="row">
			<form class="form-inline">
				<div class="form-group mb-2">
					<input type="text" class="form-control" v-model="wallet[5]">
				</div>
				<button type="submit" class="btn btn-primary mx-sm-2 mb-2" @click.prevent="registerSinger(5)">Add Singer
					6
				</button>
			</form>
		</div>
		<br>
		<div class="row">
			<button type="submit" class="btn btn-primary mx-sm-2 mb-2" @click="makeAll">Add All
			</button>
		</div>
		<br>
	</div>
</template>

<script>
	import { addSinger } from "@/service/firebaseService";
	import { accountCreate } from "@/service/accountCreate";
	import { tokenAssociate, tokenGrantKYC } from "@/service/tokenService";
	import { mapActions } from "vuex";

	export default {
		data() {
			return {
				wallet: ['singer1@gmail.com', 'singer2@gmail.com', 'singer3@gmail.com', 'singer4@gmail.com', 'singer5@gmail.com', 'singer6@gmail.com'],
				singers: [
					{
						"description": "5인조 여성 그룹이며, 특징은 댄스와 보컬이 우수합니다. 투자 마니 해주세요~",
						"id": 1,
						"price": 5000,
						"quantity": 100,
						"thumbnail_url": "indie_group_1",
						"title": "BlingBling (2021)",
						"accountId": "",
						"privateKey": "",
						"wallet": "",
					}, {
						"description": "미래 방탄입니다. 특징은 잘생긴 얼굴입니다. 투자 하면 대박 날것입니다~",
						"id": 2,
						"price": 1199,
						"quantity": 15,
						"thumbnail_url": "indie_group_2",
						"title": "BTS(2020)",
						"accountId": "",
						"privateKey": "",
						"wallet": "",
					}, {
						"description": "저를 믿고 투자 부탁드려요~~~~ 감사합니다~~~ ^^",
						"id": 3,
						"price": 1800,
						"quantity": 1,
						"thumbnail_url": "indie_group_3",
						"title": "Indie01(2020)",
						"accountId": "",
						"privateKey": "",
						"wallet": "",
					}, {
						"description": "혹시 제 연주 들어보셨나요? 완전 푹 빠지게 해드릴께요~",
						"id": 4,
						"price": 1099,
						"quantity": 2,
						"thumbnail_url": "indie_group_4",
						"title": "Indie02(2020)",
						"accountId": "",
						"privateKey": "",
						"wallet": "",
					}, {
						"description": "노래와 기타!!! 함께 하실래요? 투자와 더불어",
						"id": 5,
						"price": 656,
						"quantity": 5,
						"thumbnail_url": "indie_group_5",
						"title": "Indie03(2020)",
						"accountId": "",
						"privateKey": "",
						"wallet": "",
					}, {
						"description": "저를 키워만 주시면 황금알을 낳는 거위가 되겠습니다!",
						"id": 6,
						"price": 888,
						"quantity": 4,
						"thumbnail_url": "indie_group_6",
						"title": "Indie04(2021)",
						"accountId": "",
						"privateKey": "",
						"wallet": "",
					}]
			}
		},
		methods: {
			...mapActions(['addMessage']),
			async registerSinger(index) {
				try {
					const account = await accountCreate(this.wallet);
					const token = this.$store.getters.getAdminToken;
					await this.associateToken(account, token);
					await this.grantKYC(account, token);

					let singer = this.singers[index];
					singer.wallet = this.wallet[index];
					singer.accountId = account.accountId;
					singer.privateKey = account.privateKey;

					await addSinger(this.singers[index]);
					let message_obj1 = {
						message: "New singer's been added",
						messageClass: "success",
						autoClose: true
					}
					await this.addMessage(message_obj1);
				} catch (error) {
					let message_obj = {
						message: error.message,
						messageClass: "danger",
						autoClose: true
					}
					await this.addMessage(message_obj);
					console.log(message_obj);
				}
			},
			async associateToken(account, token) {
				const status = await tokenAssociate(token.tokenId, account);

				if (!status) {
					let message_obj = {
						message: "Associate Token failed",
						messageClass: "danger",
						autoClose: true
					}
					await this.addMessage(message_obj);
				}

			},
			async grantKYC(account, token) {
				const instruction = {
					accountId: account.accountId,
					tokenId: token.tokenId
				}

				const status = await tokenGrantKYC(instruction);
				if (!status) {
					let message_obj = {
						message: "grant KYC failed",
						messageClass: "danger",
						autoClose: true
					}
					await this.addMessage(message_obj);
				}
			},
			async makeAll() {
				await this.registerSinger(0);
				await this.registerSinger(1);
				await this.registerSinger(2);
				await this.registerSinger(3);
				await this.registerSinger(4);
				await this.registerSinger(5);
			}
		}
	}
</script>

<style scoped>

</style>